import type { ReactNode } from "react";
import { Link } from "react-router-dom";
import SiteNavbar from "@/components/feature/SiteNavbar";
import SiteFooter from "@/components/feature/SiteFooter";

interface SiteLayoutProps {
  children: ReactNode;
}

export default function SiteLayout({ children }: SiteLayoutProps) {
  return (
    <div className="min-h-screen flex flex-col bg-background-50">
      <SiteNavbar />
      <main className="flex-1 w-full pt-16 pb-24 md:pb-0">
        <div className="animate-fade-in">{children}</div>
      </main>
      <SiteFooter />

      <Link
        to="/"
        className="md:hidden fixed bottom-4 left-1/2 -translate-x-1/2 z-40 inline-flex items-center gap-2 px-5 py-3 rounded-full bg-primary-500 text-background-50 text-sm font-medium shadow-none cursor-pointer whitespace-nowrap"
      >
        <i className="ri-home-4-line"></i>
        返回首页
      </Link>
    </div>
  );
}